<template>
    <div>
        <card-header title='New Registration Fee' icon="fa-plus"/>

        <card-body>
            <rmc-fee-form :fee="newFee"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!newFee.title || !newFee.fee"
                    ><i class="fas fa-plus mr-2"></i>New Registration Fee</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import RmcFeeForm from "./FeeForm";

    import {client as http} from "@/http_client";

    export default {
        components: {RmcFeeForm, CardHeader, CardToolbar, CardBody, CardFooter},
        props: ['card', 'props'],
        data() {
            return {
                newFee: {
                    fee: 0
                }
            }
        },
        methods: {
            submit: function() {
                this.$emit('loading', true);
                http.post('rmc/fees', this.newFee, {force: true}).then(response => {
                    this.$reloadCard('rmc-fees', {confId: this.props.confId});
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the conference fee.');
                    this.$emit('loading', false);
                });
            }
        },
        mounted() {
            this.newFee.conference_id = this.props.confId
        }
    }
</script>
